import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTools} from "@fortawesome/free-solid-svg-icons";

import "./Construction.css";

export const Construction = () => {

    return (
        <div className="construction-container">
            <FontAwesomeIcon className="construction-icon" icon={faTools}/>
            <p className="construction-heading">This page is still under construction</p>
            <p className="construction-sub-heading">Please check back later...</p>
        </div>
    );
}